module.exports = "https://cdn2-fs.clearscore.com/flux/images/2d40fdc19a165ef26efb47de6eb71494.jpg";